import './CartItem.css';

import { IonAvatar, IonButton, IonCard, IonCardContent, IonCol, IonIcon, IonImg, IonLabel, IonRow, IonSpinner, IonText } from '@ionic/react';
import { closeOutline, pricetagOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import Image from '../../../components/image/Image';
import RadioItem from '../../../components/radio/RadioItem';
import InputItem from '../../../components/input/InputItem';

interface Props {
    id: number,
    title: string,
    color: string,
    image: string,
    price: string,
    quantity: number,
    max: number,
    loading: boolean,
    changeId: any,
    change: any,
    remove?: any,
    link?: string
}

const CartItem: React.FC<Props> = (props) => {
    const [quantity, setQuantity] = useState(props.quantity)

    useEffect(() => {
        setQuantity(props.quantity);
    }, [props.quantity, quantity])

    return <IonCard key={props.id} className="cart-item">
        <Image src={props.image} />

        <IonButton onClick={() => { props.remove(props.id, props.color) }} className="delete-item" shape="round" color="danger">
            <IonIcon src={closeOutline} />
        </IonButton>

        <div className="text-section">
            <IonText className="title">{props.title}</IonText>
            <IonLabel class="color">{props.color}</IonLabel>

            <IonRow className="quantity-section">
                <IonCol size="5">
                    {quantity !== undefined ? <InputItem type="select3" ltr value={quantity} change={props.change}>
                      {Array.from(Array(props.max), (e, i) => {
                        return <RadioItem value={(i+1).toString()} label={(i+1).toString()} />
                      })}
                  </InputItem> : null}
                </IonCol>
                <IonCol className="price" size="6">
                    <IonLabel>{Number(props.price).toPrice()}</IonLabel>
                </IonCol>
            </IonRow>
        </div>

        {props.loading && props.changeId == props.id + "," + props.color ?
            <div className="loading">
                <IonSpinner />
            </div> : null}
    </IonCard>
}

export default CartItem